export default "__VITE_ASSET___nWEuX1K__"